import React, { forwardRef } from 'react'
// eslint-disable-next-line no-restricted-imports
import { Input, InputProps } from 'antd'

export type { InputProps }

const defaultProps: InputProps = {
    allowClear: true,
}

const GylInput = forwardRef<Input, InputProps>((props: InputProps, ref) => {
    return <Input ref={ref} {...defaultProps} {...props} />
})

GylInput.Group = Input.Group
GylInput.Search = Input.Search
GylInput.TextArea = Input.TextArea
GylInput.Password = Input.Password

export default GylInput
